<div class="auth-page-wrapper">
  <div class="auth-form-container auth-form-side">
    <div class="auth-card" style="max-width:500px; width:100%">
      <div class="login-header">
        <img src="assets/logo.png" alt="Radio Ads Direct Logo" class="login-logo">
        <div class="auth-icon-wrap auth-icon-wrap--green" style="margin-bottom:0.875rem">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </div>
        <h1 class="auth-heading">Welcome back</h1>
        <p class="auth-subheading">Sign in to your Radio Ads Direct account</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <div class="auth-field auth-field--has-icon">
          <input class="auth-input" id="email" formControlName="email" type="email" placeholder=" ">
          <label for="email">Email</label>
          @if (emailControl?.invalid && emailControl?.touched) {
            <mat-error class="auth-error">
              @if (emailControl?.errors?.['required']) {
                Email is required
              } @else if (emailControl?.errors?.['email']) {
                Please enter a valid email address
              }
            </mat-error>
          }
        </div>

        <div class="auth-field auth-field--has-icon">
          <input class="auth-input" [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password" placeholder=" ">
          <label for="password">Password</label>
          <button type="button" mat-icon-button matSuffix class="auth-field__icon-btn" (click)="showPassword = !showPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="showPassword">
            <mat-icon>{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
          </button>
          @if (passwordControl?.invalid && passwordControl?.touched) {
            <mat-error class="auth-error">
              @if (passwordControl?.errors?.['required']) {
                Password is required
              } @else if (passwordControl?.errors?.['minlength']) {
                Password must be at least 6 characters
              }
            </mat-error>
          }
        </div>

        <div class="form-options">
          <a routerLink="/reset-password" class="forgot-link auth-forgot-link">Forgot Password?</a>
        </div>

        @if (error) {
          <div class="error-message">
            <mat-icon>error</mat-icon>
            <span>{{error}}</span>
          </div>
        }

        <div class="form-actions">
          @if (loading) {
            <button type="submit" mat-raised-button color="primary" class="login-button btn-primary btn-full btn-lg" disabled>
              <span class="btn-spinner"></span>
              Logging in...
            </button>
          } @else {
            <button type="submit" mat-raised-button color="primary" class="login-button btn-primary btn-full btn-lg" [disabled]="loginForm.invalid">
              Log In
            </button>
          }
        </div>
      </form>

      <div class="login-footer">
        <p class="auth-footer">Don't have an account? <a routerLink="/signup" class="signup-link auth-link">Sign up here</a></p>
      </div>
    </div>
  </div>
  <div class="auth-image-container">
    <img src="assets/auth/loginImage.webp" alt="Login Image">
  </div>
</div>
